import React, { useRef, useEffect } from 'react';
import { MessageCircle, Trash2, X } from 'lucide-react';
import './ChatComponent.css';

interface Message {
  id: number;
  type: 'user' | 'assistant';
  content: string;
  timestamp: string;
}

interface ChatComponentProps {
  messages: Message[];
  isVisible: boolean;
  onToggleVisibility: () => void;
  onClearChat: () => void;
  onSendMessage?: (message: string) => void;
  isProcessing?: boolean;
  className?: string;
}

const ChatComponent: React.FC<ChatComponentProps> = ({
  messages,
  isVisible,
  onToggleVisibility,
  onClearChat
}) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);
  
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };
  
  useEffect(() => {
    scrollToBottom();
  }, [messages]);
  return (
    <>
      {/* Chat toggle button */}
      <button 
        className="chat-toggle-btn"
        onClick={onToggleVisibility}
        title="Toon gesprekgeschiedenis"
      >
        <MessageCircle size={24} />
      </button>

      {/* Chat popup overlay */}
      {isVisible && (
        <div className="chat-popup-overlay" onClick={onToggleVisibility}>
          <div className="chat-popup" onClick={(e) => e.stopPropagation()}>
            <div className="chat-popup-header">
              <h3>Gesprekgeschiedenis</h3>
              <div className="chat-popup-controls">
                <button 
                  className="clear-chat-btn"
                  onClick={onClearChat}
                  title="Wis gesprek"
                >
                  <Trash2 size={20} />
                </button>
                <button 
                  className="close-chat-btn"
                  onClick={onToggleVisibility}
                  title="Sluit chat"
                >
                  <X size={20} />
                </button>
              </div>
            </div>
            
            <div className="chat-content">
              <div className="messages">
                {messages.map((message) => (
                  <div key={message.id} className={`message ${message.type}`}>
                    <div className="content">
                      {message.content}
                    </div>
                  </div>
                ))}
                {messages.length === 0 && (
                  <div className="empty-state">
                    Nog geen berichten...
                  </div>
                )}
                <div ref={messagesEndRef} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatComponent;